<template>
	<div
		v-if="enabled"
		id="g-recaptcha"
		class="g-recaptcha"
		:data-sitekey="recaptchaKey"
	/>
</template>

<script>
	export default {
		name: "Recaptcha",
		props: {
			recaptchaKey: {
				type: String,
				required: true,
			}
		},
		data () {
			return {
				widgetId: undefined,
				//Utilizado ela para não entrar em loop infinito
				hasError: false,

				//Utilizo ela para destruir o elemento
				enabled: true,
			}
		},
		mounted () {
			// render the recaptcha widget when the component is mounted
			setTimeout(() => {
				this.render()
				window.addEventListener('beforeunload', this.leaving)
			}, 500)
		},
		methods: {
			execute () {
				window.grecaptcha.execute(this.widgetId)
			},
			reset () {
				window.grecaptcha.reset(this.widgetId)
			},
			render () {
				this.enabled = true;
				this.$nextTick().then(() => {
					try {
						this.widgetId = grecaptcha.render('g-recaptcha', {
							sitekey: this.recaptchaKey,
							size: 'invisible',
							// badge: 'inline',
							callback: (response) => {
								// reset the recaptcha widget so you can execute it again
								this.reset()
								this.$emit('verify', response)
							}
						});
					} catch (e) {
						this.enabled = false;
						console.error('recaptcha', e.message)
						if (e.message === 'reCAPTCHA has already been rendered in this element') {
							this.reset()
						}

						//Essa martelada é devido já ter renderizado um elemento do recaptcha
						//Tem alguma coisa errada que não consigo atribuir o recaptcha no decorrer do formulário
						if (!this.hasError) {
							this.$nextTick().then(() => {
								this.render();
							});
							//Incremento essa variável para não entrar em um loop infinito
							this.hasError = true
						}
					}
				});
			},
			leaving() {
				console.debug('destroy recaptcha');
				this.reset()
			},
		}
	}
</script>

